import { Number, Password, Text } from './adapters';

const Field = {
  Text,
  Password,
  Number
};

export { Field };
